import ResetPassword from '../ResetPassword/ResetPassword.vue';

export default {
  name: 'UserSecurity',
  components: {
    ResetPassword,
  },
  data() {
    return {
      resetPwdDialog: false,
    };
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  methods: {
    toggleResetPwdModal(status = false) {
      this.resetPwdDialog = status;
    },
  },
};
